enum Language {
  FINNISH = 'fi',
  ENGLISH_US = 'en',
  SWEDISH = 'swe',
  GERMAN = 'de',
  NORWEGIAN_BOKMÅL = 'no',
  FRENCH = 'fr',
  DUTCH = 'nl',
  SPANISH = 'es'
}

export default Language
